import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {
  IVisitReviewForm, IVisitReviewReplyForm,
  IVisitReviewReplyTokenCheckInfo, IVisitReviewTokenCheckInfo
} from '@app/visit-reviews/models';
import { ISalonReviewsItem } from '@app/shared/models';
import { extendReviewItem } from '@app/shared/components/review-item/extend-review-item';

@Injectable({
  providedIn: 'root'
})
export class VisitReviewsService {

  constructor(private http: HttpClient) { }

  checkAddReviewToken(token: string): Observable<IVisitReviewTokenCheckInfo> {
    return this.http.post<IVisitReviewTokenCheckInfo>('/api/reviews/token-info', { token });
  }

  checkReviewReplyToken(token: string): Observable<IVisitReviewReplyTokenCheckInfo> {
    return this.http.post<IVisitReviewReplyTokenCheckInfo>('/api/reviews/replies/token-info', { token });
  }

  getReview(reviewId: string, showPartialRatings = false): Observable<ISalonReviewsItem> {
    return this.http.get<ISalonReviewsItem>(`/api/reviews/${reviewId}`)
      .pipe(map((review: ISalonReviewsItem) => extendReviewItem(review, showPartialRatings)));
  }

  addReview(reviewForm: IVisitReviewForm): Observable<void> {
    return this.http.post<void>('/api/reviews', reviewForm);
  }

  addReviewReply(reviewId: string, reviewReplyForm: IVisitReviewReplyForm): Observable<any> {
    return this.http.post<void>(`/api/reviews/${reviewId}/replies`, reviewReplyForm);
  }

}
